<div class="login">
  &nbsp;
  <div class="loginColumns animated fadeInRight gray-medium-bg b-r-lg">
    <div class="text-center">
      <div class="center-orientation">
        <img class="apm-logo" src="assets/images/SMG_colorfull.png">
      </div>
    </div>

    <form *ngIf="valid" class="m-t" (ngSubmit)="alterarSenha()">
      <h3 class="text-center">Alteração de Senha</h3>
      <div class="form-group m-b">
        <label>Nova senha</label>
        <input type="password" name="senha" class="form-control" placeholder="Nova senha" required [(ngModel)]="recuperar.senha" />
      </div>
      <div class="form-group m-b">
        <label>Confirme a senha</label>
        <input type="password" name="confirmarSenha" class="form-control" placeholder="Confirme a senha" required [(ngModel)]="recuperar.confirmarSenha" />
      </div>
      <button type="submit" class="btn btn-primary block full-width m-b">Recuperar Senha</button>
      <a routerLink="/login"><small>Voltar para o login</small></a>
      <hr />
    </form>

    <div class="m-t" *ngIf="!valid">
      <h3 class="text-center m-b">Alteração de Senha</h3>
      <h4>Código de redefinição <span class="invalid-text">inválido</span>. Tente novamente</h4>
      <a routerLink="/login"><small>Voltar para o login</small></a>
      <hr />
    </div>

    <div class="text-right mt-3">
      <img src="assets/images/logo_procergs.gif" />&nbsp; <small>&copy;{{date.getFullYear()}}</small>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>